/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { Cite, Slide, Heading, Text, Box, FlexBox, Image, Appear, Markdown } from "spectacle";
import {LeftContentRightContent, LeftCodeRightContent, LeftCodeRightMarkdown, LeftContentRightMarkdown, LeftCodeRightCode} from "components/layout";
import { simpsonsMarkHead } from "./imagesLoader";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* prettier-ignore-start */
    }
    {
      /* prettier-ignore-end */
    }
    <h3>{`Who Am I?`}</h3>
    <br />
    <h4>{`Answerer of Questions`}</h4>
    <LeftContentRightContent leftContent={<Text mdxType="Text">
      <div style={{
        textAlign: "center",
        fontSize: "3.0rem"
      }}>
        <b>@acemarke</b>
      </div>
      <div style={{
        textAlign: "center",
        fontSize: "2.5rem"
      }}>
        Twitter, Reactiflux, <br />
        Reddit, HN
      </div>
    </Text>} rightContent={<Text mdxType="Text">
      <div style={{
        textAlign: "center",
        fontSize: "3.0rem"
      }}>
        <b>@markerikson</b>
      </div>
      <div style={{
        textAlign: "center",
        fontSize: "2.5rem"
      }}>
        Stack Overflow, Github
      </div>
    </Text>} mdxType="LeftContentRightContent" />
    <h4>{`Collector of Interesting Links`}</h4>
    <LeftContentRightContent leftContent={<div style={{
      fontSize: "3.0rem",
      textAlign: "center"
    }}>
      <b>
        <a style={{
          textDecoration: "none",
          fontSize: "3.0rem"
        }} href="https://github.com/markerikson/react-redux-links">
          React/Redux Links
        </a>
      </b>
    </div>} rightContent={<div style={{
      fontSize: "3.0rem",
      textAlign: "center"
    }}>
      <b>
        <a style={{
          textDecoration: "none",
          fontSize: "3.0rem"
        }} href="https://github.com/markerikson/redux-ecosystem-links">
          Redux Ecosystem Links
        </a>
      </b>
    </div>} mdxType="LeftContentRightContent" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperSlide1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>{`Who Am I?`}</h3>
    <br />
    <h4>{`Writer of Very Long Posts`}</h4>
    <div style={{
      textAlign: "center"
    }}>
  <b>
    <a style={{
          textDecoration: "none",
          fontSize: "3.0rem"
        }} href="http://blog.isquaredsoftware.com">
      blog.isquaredsoftware.com
    </a>
  </b>
    </div>
    <LeftContentRightContent leftContent={<a href="http://blog.isquaredsoftware.com/series/idiomatic-redux" style={{
      fontSize: "3.0rem"
    }}>
      "Idiomatic Redux"
      <br />
      opinions series
    </a>} leftStyle={{
      display: "flex",
      justifyContent: "center"
    }} rightContent={<a href="https://blog.isquaredsoftware.com/2020/05/blogged-answers-a-mostly-complete-guide-to-react-rendering-behavior/" style={{
      fontSize: "3.0rem"
    }}>
      A (Mostly) Complete Guide to React Rendering Behavior
    </a>} rightStyle={{
      display: "flex",
      justifyContent: "center"
    }} mdxType="LeftContentRightContent" />
    <h4>{`Redux Maintainer`}</h4>
    <LeftContentRightContent leftContent={<div>
      <b style={{
        fontSize: "3.0rem"
      }}>Redux Docs</b>
      <ul>
        <li>
          <a style={{
            textDecoration: "none"
          }} href="https://redux.js.org/tutorials/essentials/part-1-overview-concepts">
            <b>Redux Essentials tutorial</b>
          </a>
        </li>
        <li>
          <a style={{
            textDecoration: "none"
          }} href="https://redux.js.org/tutorials/fundamentals/part-1-overview">
            <b>Redux Fundamentals tutorial</b>
          </a>
        </li>
        <li>
          <a style={{
            textDecoration: "none"
          }} href="https://redux.js.org/style-guide/style-guide">
            <b>Redux Style Guide</b>
          </a>
        </li>
        <li>
          <a style={{
            textDecoration: "none"
          }} href="https://redux.js.org/faq">
            <b>Redux FAQ</b>
          </a>
        </li>
        <li>
          <a style={{
            textDecoration: "none"
          }} href="https://redux.js.org/recipes/structuring-reducers/structuring-reducers">
            <b>Structuring Reducers</b>
          </a>
        </li>
      </ul>
    </div>} leftStyle={{
      display: "flex",
      justifyContent: "center"
    }} rightContent={<div>
      <b style={{
        fontSize: "3.0rem"
      }}>Redux Libraries</b>
      <ul>
        <li>Wrote React-Redux v7</li>
        <li>Directed React-Redux v7.1 hooks API</li>
        <li>Created Redux Toolkit</li>
      </ul>
    </div>} rightStyle={{
      display: "flex",
      justifyContent: "center"
    }} mdxType="LeftContentRightContent" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide1.isMDXComponent = true;

function MDXContentWrapperSlide2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>{`Who Am I?`}</h3>
    <br />
    <h4>{`That Guy With The Simpsons Avatar`}</h4>
    <div style={{
      display: "flex",
      flexDirection: "column"
    }}>
  <Image src={simpsonsMarkHead} height="650" mdxType="Image" />
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide2.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;

function MDXContentWrapperNotes1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes1.isMDXComponent = true;

function MDXContentWrapperNotes2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes2.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0,MDXContentWrapperNotes1,MDXContentWrapperNotes2];


export default [MDXContentWrapperSlide0,MDXContentWrapperSlide1,MDXContentWrapperSlide2]